module.exports = __webpack_public_path__ + "img/user-guide-02-07-01.bd948b3a.png";